export default __webpack_public_path__ + "static/media/39.abb8ea0b.jpg";